import { Base } from "./categorySlide.base";
import { Back } from "./components/back";
import { Header } from "./components/header";

export const CategorySlide = Object.assign(Base, {
    Back: Back,
    Header: Header
});
